var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{class:{ 'pb-4': _vm.$vuetify.breakpoint.xs }},[_c('v-col',{staticClass:"py-0 d-flex justify-space-between"},[_c('span',{staticClass:"display-1 accent--text font-weight-light pt-3"},[_vm._t("title")],2),_vm._t("right")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }